import { render, staticRenderFns } from "./DataUploadModal.vue?vue&type=template&id=f81277ee&scoped=true&"
import script from "./DataUploadModal.vue?vue&type=script&lang=ts&"
export * from "./DataUploadModal.vue?vue&type=script&lang=ts&"
import style0 from "./DataUploadModal.vue?vue&type=style&index=0&id=f81277ee&lang=less&scoped=true&"
import style1 from "./DataUploadModal.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f81277ee",
  null
  
)

export default component.exports